<template>
	<div id="usre-baseinfor" class="oh">
		<leftnav class="fl" mkcode='A' itemcode="A-ZYZ"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox">
					<div class="right_boxtitle">
						<span class="fl right_title1 current">{{ pagetitle }}</span>
						<div class="fl search-box nz-search-box">
							<span class="searchtype">专业镇</span>
							<input type="text" placeholder="请输入专业镇名称" class="search-input" v-model="searchtext"
								@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div>
						<video-teaching :type="1" seat="top"></video-teaching>
					</div>
					<div class="opport-screen-list1 qualityenterprise ">
						<dl class="opport-screen bdbe">
							<dt class="fl">省份地区</dt>
							<dd class="fl">
								<span :class="provinceid == 0 ? 'current a-screen' : 'a-screen'"
									@click="provincechoose(0, 'all'); userdata.provinceText = '全国地区'">全国地区</span>
								<span v-for="(item, index) in provincedata" :key="'prov' + index"
									@click="provincechoose(item.areaId, index); userdata.provinceText = item.areaName"
									:class="item.areaId == provinceid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="citydata.length != 0">
							<dt class="fl">城市地区</dt>
							<dd class="fl">
								<span :class="cityid == 0 ? 'current a-screen' : 'a-screen'"
									@click="choosecity(0, 'all'); userdata.cityText = ''">全部</span>
								<span v-for="(item, index) in citydata" :key="'citydata' + index"
									@click="choosecity(item.areaId, index); cityid = item.areaId; userdata.cityText = item.name"
									:data="item.areaId"
									:class="item.areaId == cityid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="countydata.length != 0">
							<dt class="fl">区县地区</dt>
							<dd class="fl">
								<span :class="countyid == 0 ? 'current a-screen' : 'a-screen'"
									@click="choosecounty(0); userdata.countyText = ''">全部</span>
								<span v-for="(item, index) in countydata" :key="'countydata' + index"
									@click="choosecounty(item.areaId); countyid = item.areaId; userdata.countyText = item.name"
									:data="item.areaId"
									:class="item.areaId == countyid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="notionlist.length > 0">
							<dt class="fl">产业分类</dt>
							<dd class="fl">
								<span @click="chooseNotion(0)"
									:class="notionCode == 0 ? 'a-screen current' : 'a-screen'">全部</span>
								<!-- <em class="num">({{item.num}})</em> -->
								<span v-for="(item, index) in notionlist" :key="'notion' + index"
									:class="notionCode == item.notionCode ? 'a-screen current' : 'a-screen'"
									@click="chooseNotion(item.notionCode)">{{ item.notion }}<em
										class="num">({{ item.num }})</em></span>
							</dd>
						</dl>
					</div>
				</div>

				<div class="whitebox" style="min-height: 160px;">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
						<p class="fl" v-if="kwtextsearch">产业大脑为您找到<span class="searchnum">{{ total }}</span>条【 <span
								class="orangefont">{{ kwtextsearchtext }}</span>】相关结果</p>
						<div :class="exportbtn ? 'fr enlistexportbtn' : 'fr enlistexportbtn disable'"
							@click="enlistExport()" v-if="userdata.groupType == 1"
							v-show="exportnum > 0 && enterpirseList.length > 0">
							<span>导出数据</span>
						</div>
					</div>
					<div class="enterprise_list_box">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>专业镇</th>
								<th>专业</th>
								<th>所属产业</th>
								<th>所在地</th>
								<th>企业数</th>
								<th>编辑</th>
							</tr>
							<tr v-for="(list, index) in enterpirseList" :key="index" v-if="index < freeUserNum">
								<td>{{ (page - 1) * pageSize + index + 1 }}</td>
								<!-- 	<td v-if="userdata.groupType == 0"><span :class="list.locking?'title onlinetitle td_locktitle locking':'title onlinetitle td_locktitle unlock'" @click="pagelockfun(list.id,list.locking)">{{list.town}}</span><span :class="list.locking?'td_lockimg locking':'td_lockimg unlock'	"></span></td>
								<td v-if="userdata.groupType > 0"><span  class="title onlinetitle" @click="routerlinkid(currentHref,list.id)">{{list.town}}</span></td> -->
								<td><span class="title onlinetitle"
										@click="routerlinkid(currentHref, list.id)">{{ list.town }}</span></td>
								<td>{{ list.title }}</td>
								<td>{{ list.notion }}</td>
								<td>{{ list.area }}</td>
								<td>{{ list.enterpriseNum }}</td>
								<td class="collectfont1"><span @click="listToggleCollect(list, 'acoc')">{{ list.collectId
									== 0 ?'加入':'移除'}}关注</span></td>
							</tr>
						</table>
						<div class="w95mg">
							<freeUserTips :type="1" :bgtype="21" v-if="enterpirseList.length > 2 && userdata.isFree">
							</freeUserTips>
						</div>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>
			</div>
			<!-- 解锁试用弹框 -->
			<div class="tipspopbox_bg" v-if="userdata.groupType == 0" v-show="permissionsbtn">
				<div class="tipspopbox_acoc">
					<span class="closebtn" @click="permissionsbtn = false"></span>
					<h4 class="numtips">目前剩余可解锁次数：<span class="num">{{ permissionsCount }}</span></h4>
					<!--     background: linear-gradient(180deg,#fff8e9,#fff);-->
					<strong class="bluetips db">试用账户可免费解锁三家专业镇<br />升级至正式版可获得全部访问权限</strong>
					<div class="btnbox">
						<span class="basebtn fl" @click="lockPermission">确定解锁</span>
						<span class="graybtn fr" @click="permissionsbtn = false">取消</span>
					</div>
				</div>
			</div>
			<!-- 导出列表弹框 -->
			<div class="enlistexportPop" v-show="exportpop">
				<div class="enlistexportPop_box">
					<h5 class="title">产业大脑为您找到<span class="searchnum">{{ total }}</span>条相关结果</h5>
					<p class="smtips">单次最多导出500条，每日最多可以导出10次</p>
					<p class="tips">本次可导出<b class="redfont">{{ total > 500 ? 500 : total }}</b>条，今日剩余次数<b
							class="redfont">{{ exportnum }}</b>次</p>
					<span class="determinebtn" @click="exportlistFun()">{{ confirmtext }}</span>
					<span class="closebtn" @click="exportpop = false"></span>
				</div>
			</div>
			<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe>
		</div>
	</div>
</template>
<script>
import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"
import { mapState, mapMutations, mapGetters } from "vuex";
import {
	dataInJs
} from "../../utils/city.js";
export default {
	name: 'professionalTown',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			userdata: {}, searchtype: 1,
			title: '专业镇列表',
			pagetitle: '专业镇',
			searchtext: "",
			fenkd: { children: [] },
			selectcitydata: [],
			notionlist: [],
			notionCode: 0,
			provinceid: 0,
			cityid: 0,
			countyid: 0,
			provincedata: dataInJs(),
			citydata: [],
			countydata: [],
			permissionsbtn: false,//使用账户查看次数权限弹框开关
			permissionsCount: 3,//使用账户查看次数权限弹框次数
			currentHref: "/professionalTownDetail", currentid: 0,//点击出现解锁弹框时保存的协会id
			/*--公用*/
			kwtextsearch: false,
			kwtextsearchtext: "",
			enterpirseList: [],
			showscreen: true,
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数 
			exportnum: 0, //导出次数
			exportpop: false, //点击导出按钮弹框显示
			allowexport: false, //后台判断是否可以上传
			exportbtn: true, //loading小 等待转圈圈
			confirmtext: '确认导出',
			iframeurl: '',
			freeUserNum: 3,
			isShowFreeUserTips: false,
		}
	},
	components: {
		freeUserTips
	},
	created() {
		this.bus.$emit('loading', true);
		this.userdata = this.getuseriformation();
		this.freeUserNum = this.userdata.isFree ? 3 : this.pageSize;
	},
	mounted() {
		// this.getTownNotionList();
		this.getCompanyList();
	},
	methods: {
		//概念单选 层级显示
		chooseNotion(code) {
			if (!this.userdata.token) {
				this.isShowFreeUserTips = true;
				return;
			}
			this.notionCode = code;
			this.getCompanyList(1, 'notion');
		},
		pageHandler: function (page) {
			if (page > 1 && this.userdata.isFree) {
				this.$message({ type: 'warning', message: "本账号试用期已截止,如需延期请即刻与我们联系" });
				return;
			}
			// console.log('pageHandler',this.userdata.groupType==0,page > 2)
			this.getCompanyList(page, 'notion');
		},
		//省份城市选择
		provincechoose(id, i) {
			if(!this.userdata.token){
				this.isShowFreeUserTips = true;
				return;
			}
			this.provinceid = id;
			this.cityid = 0;
			this.countyid = 0;
			this.countydata = [];
			if (i != "all" && this.provincedata[i].children != null) {
				this.citydata = this.provincedata[i].children;
			} else {
				this.citydata = [];
			}
			this.page = 1;
			this.getCompanyList();
		},
		choosecity(id, i) {
			//	console.log('choosecity',id);
			this.cityid = id;
			this.countyid = 0;
			if (i != "all" && this.citydata[i].children != null) {
				this.countydata = this.citydata[i].children;
			} else {
				this.countydata = [];
			}
			this.page = 1;
			this.getCompanyList();
		},
		choosecounty(id) {
			//	console.log('choosecity',id);
			this.countyid = id;
			this.page = 1;
			this.getCompanyList();
		},
		//获取专业镇的概念展示
		// getTownNotionList(){ 
		// 	var ajaxurl=this.$api.cyl.specialTown.notionList();
		// 	var _this=this;
		// 	this.getAxiosData(ajaxurl,this.userdata.token,function(res){
		// 	_this.notionlist = res.list;  
		// 	// console.log('获取专业镇的概念展示',res.list)
		// 	_this.getCompanyList();
		// 	})
		// }, 
		getCompanyList(pages, notiontype) {
			this.bus.$emit('loading', true);
			var _this = this;
			this.page = pages ? pages : 1;;
			this.notionCode = notiontype ? this.notionCode : '';
			var notionja = this.splicing('notionCode', this.notionCode);
			var kwaja = this.splicing('kw', this.searchtext);
			var countyidja = this.splicing('county', this.countyid);
			var provinceidja = this.splicing('province', this.provinceid);
			var cityidja = this.splicing('city', this.cityid);
			let ajaxurl = this.$api.cyl.specialTown.list() + '?page=' + this.page + notionja + kwaja + countyidja + provinceidja + cityidja;
			// console.log(ajaxurl);
			this.getAxiosData(ajaxurl, this.userdata.token, function (resdata) {
				// _this.notionlist = resdata.list; 
				console.log('专业镇列表', resdata)
				//行业数量展示  
				let arrNum = resdata.data.cityIndustryList.filter(list => {
					return list.num > 0;
				});
				_this.notionlist = arrNum;


				_this.enterpirseList = resdata.list;
				_this.enterpirseList.forEach(list => {
					list.locking = !list.unlock;
				})
				_this.totalPage = resdata.totalPage;
				_this.pageSize = resdata.pageSize;
				_this.total = resdata.totalRecord;
				// _this.permissionsCount=resdata.data.unlockRemainder; 
				// _this.exportnum = resdata.extend.exportRemainder;
				_this.bus.$emit('loading', false);
			})
		},
		//搜索关键词----------------------------------------------公用
		searchkwfun() {
			if(!this.userdata.token){
				this.isShowFreeUserTips = true;
				this.searchtext='';
				return;
			}
			this.searchtext = $.trim(this.searchtext);
			// if(this.searchtext!="" || ){
			this.getCompanyList();
			// } 
		},
		searchenter(e) {
			if (e.keyCode == 13) {
				this.searchkwfun();
			}
		},
		//页面最顶部的解锁判断
		pagelockfun(id, lock) {
			var currentHref = this.currentHref + id;
			this.currentid = id;
			if (!lock) {
				this.routerlinkid(this.currentHref, id);
			} else {
				if (this.permissionsCount > 0) {
					this.permissionsbtn = true;
				} else {
					this.bus.$emit('tipspop', { lock: true, type: "permissionNum" });
				};
			}
			// this.routerself(this.currentHref);
		},
		//确定解锁的判断
		lockPermission() {
			// console.log(this.currentHref,this.permissionsCount);  
			this.permissionsCount--;
			this.permissionsbtn = false;
			var cuid = this.currentid;
			this.enterpirseList.forEach(list => {
				if (list.id == cuid) {
					list.locking = false;
				}
			})
			this.routerlinkid(this.currentHref, this.currentid);
		},
		//加入、移除目标企业
		collectToggle(list) {
			if(!this.userdata.token){
				this.isShowFreeUserTips = true;
				return;
			}
			console.log('移除目标企业', list);
			var _this = this, cid = list.collectId;
			var ajaxurl = "", ajaxdata = {};
			if (cid == 0) {
				ajaxurl = this.$api.cyl.collect.add();
				ajaxdata = { type: list.collectType, id: list.id }
			} else {
				ajaxurl = this.$api.cyl.collect.remove();
				ajaxdata = { collectId: list.collectId };
			}
			$.ajax({
				type: "POST",
				url: ajaxurl,
				data: ajaxdata,
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					// console.log('1123',res);
					if (res.success) {
						if (cid == 0) {
							list.collectId = res.data.collectId;
						} else {
							list.collectId = 0;
						}
					}
				}
			})
		},
		//企业列表导出数据
		enlistExport() {
			if (this.exportbtn) {
				this.exportpop = true;
			}
			// console.log(this.userdata.groupType,this.exportnum,this.allowexport,this.total);  
			// var ajaxurl=this.$api.cyl.enterprise.export()+'?token='+this.token+'&type='+this.searchtype+'&search=1&city='+this.cityid+'&province='+this.provinceid+'&county='+this.countyid+notionja+tagaja+kwaja+';
		},
		exportlistFun() { //下载报告
			var _this = this;
			var ajaxurl = this.getajaxUrl(this.$api.cyl.enterprise.export()) + '&token=' + this.userdata.token;
			this.confirmtext = "导出中";
			var iframe = document.getElementById("exportIframe");
			iframe.setAttribute("src", ajaxurl);
			_this.exportnum = this.exportnum--;
			setTimeout(() => {
				_this.confirmtext = "导出成功";
				_this.exportpop = false;
				_this.exportbtn = false;
			}, 5000)
			setTimeout(() => {
				_this.exportbtn = true;
				_this.confirmtext = "确认导出";
				// console.log('一分钟冷却计时')
			}, 60000)
		},
	}
}
</script>

<style></style>
